import QuestionHeader from "../component/QuestionHeader";
import QuestionFooter from "../component/QuestionFooter";
import {useEffect, useState} from "react";
import TextareaAutosize from "react-textarea-autosize";
import {useParams} from "react-router-dom";
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import useForm from "../../../../hooks/useForm";
import URLS from "../../../../API/Axios/URLS";
import FormNoneFieldErrors from "../../../../components/Form/FormNoneFieldErrors";
import AnswerDropDown from "../component/AnswerDropDown";
import {tokenizeSentence} from "../../../../utils/utils";
import GenericQuestionModal from "../Modal/GenericQuestionModal/GenricQuestionModal";


function MapQuestion({question, answer, setAnswer}) {

    return (
        <div className={"w-full flex text-bawa flex-col md:w-2/3 self-center text-wrap gap-8  rounded-2xl p-3"}>
            <div className={"flex  justify-center rounded text-wrap flex-col gap-4"}>
                {question?.text?.split("\n").map((item, index) => (
                    <p key={index}>{item}</p>
                ))}

            </div>
            <div className={"flex flex-1 items-center w-full flex-col gap-4"}>
                <TextareaAutosize
                    minRows={10}
                    placeholder="Write your answer here"
                    value={answer}
                    onChange={(e) => setAnswer(e.target.value)}

                    className="w-full  rounded-lg border-2 text-black-2 dark:text-white border-b-graydark bg-white py-2 px-2 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                ></TextareaAutosize>
                <div className={"flex w-full  flex-row-reverse"}>
                    Word Count : {answer.trim().length !== 0 ? answer.trim().split(" ").length : "0"}
                </div>
            </div>


        </div>
    )
}


export default function SummarizeTheScenario({className, ...props}) {
    const {question, questionActions} = useQuestion()
    const [showModal, setShowModal] = useState(false)
    const {id} = useParams()
    const [form, error, loading, setFormData, actions] = useForm({
        questionId: id,
        answer: "",
        time: 0
    })
    const [response, setResponse] = useState({})


    function submitAnswer() {
        if (tokenizeSentence(form?.answer).length < 30) {
            actions.setError({
                non_field_errors: [`Answer should be at least 30 words`]
            })
            return
        }
        actions.post(URLS.genericQuestionView, (data) => {
            let totalTimeInSec = (Date.now() - data.time) / 1000
            // remove decimal points
            totalTimeInSec = Math.floor(totalTimeInSec)

            return {
                ...data,
                time: totalTimeInSec
            }
        }).then(response => {
            setResponse(response?.data)
            setShowModal(true)
            setFormData({
                time: 0
            })
        })

    }


    useEffect(() => {
        questionActions.loadQuestions(id)
    }, [id])


    return (
        <div className={`rounded-lg shadow-lg p-4 ${className}`}>
            <QuestionHeader  {...question}
                             timeLimit={question?.timeLimit && question?.timeLimit + 5000}

            />
            <GenericQuestionModal
                result={response}
                showModal={showModal} setShowModal={setShowModal}/>
            <div className={" flex flex-col items-center md:flex-row p-2 py-8 justify-center gap-8"}>
                <div className={"flex flex-1 px-8 flex-col justify-center gap-4"}>
                    <MapQuestion question={question} answer={form?.answer} setAnswer={(e) => {
                        if (form.time === 0) {
                            form.time = Date.now()
                        }
                        setFormData({
                            answer: e
                        })
                    }}/>
                    <FormNoneFieldErrors errors={error?.answer || error?.non_field_errors || error?.time}/>


                </div>


            </div>


            <QuestionFooter className={"mx-4 my-2"}
                            loading={loading}
                            onClickSubmit={submitAnswer}

            />

            <AnswerDropDown
                className={" mt-4 "}
                headerTitle={"Show Answer"}
                allowEditing={true}

                justifications={question?.answerText}
            />

        </div>

    )
}
